import React from 'react';
import GeckoFieldBase from '../_base';
import Switch from '../../../switch/switch';

class GeckoFieldToggle extends GeckoFieldBase {

    handleSwitchChange(checked) {
        return this.props.handler(this.field().key, checked);
    }

    render() {
        return (
            <div className="flex items-start gap-3">
                <Switch
                    id={this.renderId()}
                    checked={this.value() || false}
                    onCheckedChange={this.handleSwitchChange.bind(this)}
                    disabled={this.isDisabled()}
                    aria-label={this.renderAriaLabel()}
                    className="mt-[2px]"
                />
                <div className="flex flex-col">
                    <label 
                        htmlFor={this.renderId()} 
                        className="text-sm font-medium text-foreground cursor-pointer"
                    >
                        {this.field().label}
                    </label>
                    {this.field().description && (
                        <p className="text-xs text-muted-foreground">
                            {this.field().description}
                        </p>
                    )}
                </div>
            </div>
        );
    }
    
}

export default GeckoFieldToggle;